import { useMemo } from 'react';
import isEmpty from '@core/lodash/isEmpty';
import isString from '@core/lodash/isString';
/**
 * Returns the unit for the selected options of a product.
 */
export const useSelectedOptionProductUnit = ({ product, }) => {
    const selectedOptionUnit = useMemo(() => {
        if (!isString(product?.selected_product_unit_id) ||
            isEmpty(product?.selected_product_unit_id)) {
            return undefined;
        }
        const productUnits = product?.product_units || [];
        const matchingUnit = productUnits.find((unit) => {
            return unit.id === product?.selected_product_unit_id;
        });
        return matchingUnit;
    }, [product?.product_units, product?.selected_product_unit_id]);
    return selectedOptionUnit;
};
